import React, { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../CustomComponents/FieldInput";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";
import LoginLoaderButton from "../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import axiosInstance from "../../../redux/api";
import {
  getCategary,
  getSkillswithCategory,
} from "../../../redux/categary/action";
import { addPortfolio, updatePortfolio } from "../../../redux/profile/action";
import {
  descriptionvalidation,
  filesvalidationforstatusbase,
  titlevalidation,
  validurlvalidation,
} from "../../Common/commonvalidation";
import CompanyFileUpload from "../ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";
import CommonAddSkills from "../../Common/CommonAddSkills";

const bxpDatatomap = [
  { title: "Project title", name: "title", placeholder: "Enter title" },
  {
    title: "Upload file* (Upload at least 1 file)",
    name: "files",
    placeholder: "Drag and drop or Browse file",
  },
  { title: "Competencies Suggestions", name: "skills", placeholder: "skills" },
  { title: "Project URL", name: "url", placeholder: "Enter url" },
  {
    title: "Project Description",
    name: "description",
    placeholder: "Enter detailed Description & specifications",
  },
];

const AddPortfolio = ({
  setActiveTab,
  work_sample,
  selectedItemId,
  setModalOpen,
}) => {
  const [loading, setLoading] = useState(null);
  const dispatch = useDispatch();


  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  // ✅ Normalize skill objects (convert skill_id → id)
  const [popularSkills, setPopularSkills] = useState([]);
  const [allSkills, setAllSkills] = useState([]);
  const skillsss = useSelector(({ categary: { skilllistwithcategory } }) => skilllistwithcategory);
  const normalizeSkills = (skills) => Array.isArray(skills) ? skills.map((s) => ({ id: s.id ?? s.skill_id, title: s.title, })) : [];

  useEffect(() => {
    setAllSkills(Array.isArray(skillsss) ? skillsss : []);
    setPopularSkills(Array.isArray(skillsss) ? skillsss : []);
  }, [skillsss]);

  const initialValues = {
    title: work_sample?.title || "",
    url: work_sample?.url || "",
    description: work_sample?.description
      ? work_sample.description.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
      : "",
    skills: normalizeSkills(work_sample?.skills) || [],
    files: work_sample?.files || [],
  };

  const validationSchema = Yup.object().shape({
    title: titlevalidation,
    url: validurlvalidation,
    files:filesvalidationforstatusbase,
    skills: Yup.array()
      .min(3, "Please select at least 3 competencies")
      .required("Skills are required"),
    description: descriptionvalidation,
  });

  useEffect(() => {
    const path = "Assets/scss/FirstTimeUsers.module.scss";
    LoadCSSforfirstTime(path);
    dispatch(getCategary());
  }, []);

  const getCategoryIds = (categories) => {
    if (!Array.isArray(categories)) return "";
    const ids = categories.flatMap((cat) => [
      cat.id,
      ...(Array.isArray(cat.sub_categories)
        ? cat.sub_categories.map((sub) => sub.id)
        : []),
    ]);
    return ids.join(",");
  };

  useEffect(() => {
    const categoryIds = getCategoryIds(profile?.categories);
    if (categoryIds) {
      dispatch(getSkillswithCategory(categoryIds));
    }
  }, [profile?.categories]);

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...values, id: selectedItemId };

    try {
      if (selectedItemId !== 0) {
        dispatch(updatePortfolio(updatedData));
      } else {
        dispatch(addPortfolio(updatedData));
      }
      setModalOpen(false);
      setActiveTab("WorkSamples");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);
          resetForm();
        }}
      >
        {(formik) => (
          <Form>
            {bxpDatatomap.map((prop, key) => {
              if (prop.name === "skills") {
                return (
                  <React.Fragment key={key}>
                    <CommonAddSkills
                      popularSkills={popularSkills}
                      allSkills={allSkills}
                      parentselectedskills={formik?.values?.skills}
                      formik={formik}
                    />
                    <ErrorMessage
                      name={prop.name}
                      component="div"
                      className="error"
                      style={{ color: "red" }}
                    />
                  </React.Fragment>
                );
              }

              if (prop.name === "description") {
                return (
                  <React.Fragment key={key}>
                    <CustomReactQuill
                      value={formik.values[prop.name] || ""}
                      formik={formik}
                      name={prop.name}
                      title={prop.title}
                    />
                    <ErrorMessage
                      name={prop.name}
                      component="div"
                      className="error"
                      style={{ color: "red" }}
                    />
                  </React.Fragment>
                );
              }

              if (prop.name === "files") {
                return (
                  <div key={key} className="add-portfolio upload-item-images ">
                    <h6 className="skill-right file-attachment">
                      Upload Item Images  
                    </h6>
                    <CompanyFileUpload formik={formik} name="files" />
                    <ErrorMessage
                      name={prop.name}
                      component="div"
                      className="error"
                      style={{ color: "red" }}
                    />
                  </div>
                );
              }

              return (
                <FieldInput
                  key={key}
                  title={prop.title}
                  name={prop.name}
                  placeholder={prop.placeholder}
                />
              );
            })}

            <div className="button-container pb-4">
              <button className="next-button w-100" type="submit">
                {loading ? (
                  <LoginLoaderButton />
                ) : selectedItemId ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddPortfolio;
